import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const submitForm = (payload) => axios.post(`${API}/submissions`, payload);
export const fetchStats = () => axios.get(`${API}/stats`);
export const fetchPublicStats = () => axios.get(`${API}/public/stats`);
export const fetchPublicDatabase = () => axios.get(`${API}/database/public`);
export const submitSurvey = (payload) => axios.post(`${API}/database-survey`, payload);
export const fetchAdminSettings = () => axios.get(`${API}/admin/settings`, { withCredentials: true });
export const saveAdminSettings = (payload) => axios.put(`${API}/admin/settings`, payload, { withCredentials: true });

export const adminLogin = (email, password) =>
  axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true });
export const adminLogout = () => axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
export const adminMe = () => axios.get(`${API}/auth/me`, { withCredentials: true });
export const fetchSubmissions = (type) =>
  axios.get(`${API}/submissions${type ? `?type=${type}` : ""}`, { withCredentials: true });
export const fetchAdminSurveys = () => axios.get(`${API}/admin/surveys`, { withCredentials: true });
export const resendEmails = (id) => axios.post(`${API}/admin/submissions/${id}/resend-emails`, {}, { withCredentials: true });
